import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { checkIfNewContentAvailable, setNewContentAvailable } from 'services/utils';
import Home from 'pages/Home/Home';

export default function HomeWrapper() {
	const navigate = useNavigate();
	const location = useLocation();

	function navigateToPath(path, state) {
		navigate(path, state);
	}

	useEffect(() => {
		const refreshNeeded = checkIfNewContentAvailable();

		if (refreshNeeded) {
			setNewContentAvailable(false);
			navigateToPath('/portal/?upgrade=true');
			window.location.reload();
		}
	}, [navigate, location?.state]);
	return <Home navigate={navigateToPath} location={location} />;
}
